<template>
  <div>
    <template v-for="(item,i) in titles">
      <title-block :key="i" :id="'bm'+item.label" v-if="item.num">
        <template slot="title">{{item.label}}</template>
        <div class="mt-10">
          <el-table v-loading="item.loading" :data="tableDatas(item.moduleId)" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <template v-for="(item1, j) in tableFields(item.moduleId)">
              <el-table-column :min-width="item.minWidth+'px'" :fixed="item.fixed || false" v-if="item.field !== 'link'" :key="j" :prop="item.field" :label="item.fieldName" align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <a class="textOverflow" style="width:100%;color:#409eff" rel="noopener noreferrer" v-if="['bidHeadLine','headLine'].includes(item1.field)" :underline="false" type="primary"
                    :href="columnValueOth(item.moduleId,j)" target="_blank">{{columnValue(scope.row[j], item.moduleId)}}</a>
                  <a class="textOverflow" style="width:100%;color:#409eff" rel="noopener noreferrer" v-if="['website'].includes(item1.field)" :underline="false" type="primary"
                    :href="addUrl3W(columnValue(scope.row[j], item.moduleId))" target="_blank">{{addUrl3W(columnValue(scope.row[j], item.moduleId))}}</a>
                  <span
                    v-else-if="item1.field == 'webResponseSpeed'">{{ columnValue(scope.row[j], item.moduleId) != 0 ? (columnValue(scope.row[j], item.moduleId)?(columnValue(scope.row[j], item.moduleId)+'毫秒'):'--') : '--' }}</span>
                  <span v-else>{{columnValue(scope.row[j], item.moduleId) || '--'}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
          <pagination :pageNum="tablePage(item.moduleId)" :total="tableTotal(item.moduleId)" @currentChange="val => boxCurrentChange(val, i)" />

          <!-- <el-table v-loading="item.loading" :data="item.tableList" :header-cell-style="{background: '#fafafa',color: '#333'}" tooltip-effect="light">
            <template v-for="(item,i) in item.tableKeys">
              <el-table-column :min-width="item.minWidth+'px'" :fixed="item.fixed || false" v-if="item.key !== 'link'" :key="i" :prop="item.key" :label="item.label" align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <a class="textOverflow" style="width:100%;color:#409eff" rel="noopener noreferrer" v-if="item.key == 'bidHeadLine'" :underline="false" type="primary" :href="scope.row['link']"
                    target="_blank">{{scope.row[item.key] || '--'}}</a>
                  <a class="textOverflow" style="width:100%;color:#409eff" rel="noopener noreferrer" v-else-if="item.key == 'headLine'" :underline="false" type="primary" :href="scope.row['link']"
                    target="_blank">{{scope.row[item.key] || '--'}}</a>
                  <a class="textOverflow" style="width:100%;color:#409eff" rel="noopener noreferrer" v-else-if="item.key == 'website' && scope.row[item.key]" :underline="false" type="primary"
                    :href="addUrl3W(scope.row[item.key])" target="_blank">{{scope.row[item.key]?addUrl3W(scope.row[item.key]):'--'}}</a>
                  <span v-else-if="item.key == 'webResponseSpeed'">{{ scope.row[item.key] != 0 ? (scope.row[item.key]?(scope.row[item.key]+'毫秒'):'--') : '--' }}</span>
                  <span v-else-if="item.key == 'baiduCount'">{{scope.row[item.key]}}</span>
                  <span v-else-if="item.key == 'qihoo360Count'">{{scope.row[item.key]}}</span>
                  <span v-else-if="item.key == 'sougouCount'">{{scope.row[item.key]}}</span>
                  <span v-else-if="item.key == 'baiduWeight'">{{scope.row[item.key]}}</span>
                  <span v-else-if="item.key == 'baiduMobileWeight'">{{scope.row[item.key]}}</span>
                  <span v-else-if="item.key == 'sougouWeight'">{{scope.row[item.key]}}</span>
                  <span v-else-if="item.key == 'qihoo360Weight'">{{scope.row[item.key]}}</span>
                  <span v-else>{{scope.row[item.key] || '--'}}</span>
                </template>
              </el-table-column>
            </template>
          </el-table> -->
          <!-- <pagination :page-size="item.param.pageSize" :pageNum="item.param.pageNum" :total="item.total" @currentChange="val => boxCurrentChange(val, i)" /> -->
        </div>
      </title-block>
    </template>
  </div>
</template>
<script>
import mixin from '../mixins/enterpriseTabs'
import { getByPageV2 } from '../api/newClueApi'
export default {
  mixins: [mixin],
  name: 'businessBox',
  props: {
    tabsInfo: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      titles: [
        // { type: '', label: '网站基本信息', num: 0, moduleId: '' },
        // { type: '', label: '网络推广', num: 0, moduleId: '' },
      ]
    }
  },
  computed: {
    columnValueOth() {
      return (id, idx) => {
        return this.searchActive(id)?.fieldData[idx][4]
      }
    },
  },
  mounted() {
    this.titles = this.tabsInfo
  },
  methods: {
    // 分页
    boxCurrentChange(val, i) {
      // const param = this.titles[i]['param']
      // param.pageNum = val
      // this.getInfo(i, param)
      const sign = i + 17
      this.$emit('pageTurn', val, sign) // index 是 titles 的下标

    },

  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-table th > .cell {
  font-size: 12px;
  font-weight: 400;
}
/deep/ .el-table th {
  padding: 10px 0;
  line-height: 16px;
}

/deep/ .el-table .cell {
  font-size: 12px;
  font-weight: 400;
  span {
    font-size: 12px;
  }
}

.tables /deep/ .el-table__header {
  width: 100% !important;
}
.tables /deep/ .el-table__body {
  width: 100% !important;
}
::v-deep {
  #bm2,
  #bm3 {
    .el-table {
      .el-table__cell.is-center {
        text-align: left;
        &:nth-of-type(1) {
          padding-left: 30px;
          box-sizing: border-box;
        }
      }
      .cell {
        padding-left: 0;
      }
    }
  }
}
</style>